export default "__VITE_ASSET__B4eZ4cij__"